import { flex, opacityEffect, breakpoints } from "../styles/utils";
import styled from "styled-components";

export const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 52px;
  padding-top: 20px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;

  justify-content: space-between;
  align-items: center;
  display: flex;

  .close-icon {
    ${opacityEffect}
    color: var(--black-100);
  }

  .back-icon {
    ${opacityEffect}
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;

  /* Hide scrollbars for WebKit browsers */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbars for Firefox */
  scrollbar-width: none;

  /* Optional: Add padding to prevent content from touching edges */
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
`;

export const FormContainer = styled.div`
  ${flex("column")}
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;

  /* Hide scrollbars for WebKit browsers */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbars for Firefox */
  scrollbar-width: none;
`;

export const SelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 85vh;
  margin-bottom: 8px;
  max-height: 660px;
  position: relative;
  background: var(--gray-300);
  border-radius: 8px;

  @media (max-width: ${breakpoints.tablet}) {
    height: 100%;
    width: 100%;
    max-height: 100%;
    border-radius: 0px;
    position: fixed;
    bottom: 0;
    right: 0;
    top: 0;
    left: 0;
    margin: 0;
    z-index: 50;
    padding-bottom: env(safe-area-inset-bottom);
  }
`;

export const FooterContainer = styled.div`
  height: 90px;
  width: 100%;
`;

export const FormErrorContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  background: var(--white);
  border-radius: 8px;
  border: none;
`;

export const TextError = styled.h3`
  color: var(--red);
  text-align: center;
  padding-top: 10px;
`;
